<template>
  <div class="chapter chapter5">
    <video autoplay muted loop id="redVideo" :src="video">
    </video>
    <div v-if="slide === 1" class="red-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" styleType="red" hideLogo="false" />
      <div class="content-container">
        <div class="container h-100 pt-5">
          <div class="row justify-content-center">
            <div class="col-8">
              <div class="mail-container">
                <div class="mail-header">
                  <div class="mail-header-top">
                    <img class="icon" src="@/assets/envelope.svg" width="32" height="32" />
                    <span class="title">Tabbot E-Mailer Pro 2000</span>
                  </div>
                  <div class="mail-header-functions">
                    <div class="row justify-content-center">
                      <div class="col">
                        <img class="icon" src="@/assets/reply-fill.svg" width="16" height="16" />
                        <span class="label">Reply</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/reply-all-fill.svg" width="16" height="16" />
                        <span class="label">Reply All</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/forward-fill.svg" width="16" height="16" />
                        <span class="label">Forward</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/bookmark-plus-fill.svg" width="16" height="16" />
                        <span class="label">Mark</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/trash.svg" width="16" height="16" />
                        <span class="label">Delete</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mail-content">
                  <div class="from">
                    <span class="label">From:</span>
                    <span class="text">{{ $t('chapter5.slide1.from') }}</span>
                  </div>
                  <div class="to">
                    <span class="label">To:</span>
                    <span class="text">{{ $t('chapter5.slide1.to') }}</span>
                  </div>
                  <div class="subject">
                    <span class="label">Subject:</span>
                    <span class="text">{{ $t('chapter5.slide1.subject') }}</span>
                  </div>
                  <div class="attachment">
                    <span class="label">Attachments:</span>
                    <button @click="navigateTo(2)">phoenix.jpg (2,1MB)</button>
                  </div>
                  <div class="mail-text" v-html="$t('chapter5.slide1.mailtext')"></div>
                </div>
                <div class="mail-footer">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" />
    </div>
    <div v-if="slide === 2" class="red-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" styleType="red" hideLogo="false" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <div class="wimmelbild">
                <img class="sourceImg" src="https://tabbot-central.b-cdn.net/images/Platine_0007_Platine-leer.png" />
                <div class="interactive-content">
                  <div v-bind:class="['error', 'error-1', errors[1] ? '' : 'hidden']" @click="errorFound(1)"><img src="@/assets/Platine_0000_1.png" /></div>
                  <div v-bind:class="['error', 'error-2', errors[2] ? '' : 'hidden']" @click="errorFound(2)"><img src="@/assets/Platine_0001_2.png" /></div>
                  <div v-bind:class="['error', 'error-3', errors[3] ? '' : 'hidden']" @click="errorFound(3)"><img src="@/assets/Platine_0002_3.png" /></div>
                  <div v-bind:class="['error', 'error-4', errors[4] ? '' : 'hidden']" @click="errorFound(4)"><img src="@/assets/Platine_0003_4.png" /></div>
                  <div v-bind:class="['error', 'error-5', errors[5] ? '' : 'hidden']" @click="errorFound(5)"><img src="@/assets/Platine_0004_5.png" /></div>
                  <div v-bind:class="['error', 'error-6', errors[6] ? '' : 'hidden']" @click="errorFound(6)"><img src="@/assets/Platine_0005_6.png" /></div>
                  <div v-bind:class="['error', 'error-7', errors[7] ? '' : 'hidden']" @click="errorFound(7)"><img src="@/assets/Platine_0006_7.png" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" />
      <div class="hints red">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <form>
                <div>
                  <span class="hints-text">{{ $t('common.hints') }} </span>
                  <button class="btn" @click="showHint(0, 0)">1</button>
                  <button v-if="riddles[0].hintsShown[0]" class="btn" @click="showHint(0, 1)">2</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[0]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter5.slide2.hints.1') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[1]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter5.slide2.hints.2') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showSolution" class="overlay">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 solution">
            <h4 v-html="$t('chapter5.slide2.solution')"></h4>
            <br />
            <button class="btn btn-danger" @click="nextRiddle">{{ $t('common.button.next') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="slide === 3" class="red-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" styleType="red" hideLogo="false" />
      <div class="content-container">
        <div class="container h-100">
          <div class="row justify-content-center">
            <div v-if="showFinal" class="col-10">
              <video autoplay id="finale" ref="finale">
                <source src="https://tabbot-central.b-cdn.net/video/finale.mp4" type='video/mp4' />
              </video>
            </div>
            <div v-else class="col-6 pt-5 text-center">
              <h4 v-html="$t('chapter5.slide3.points')"></h4>
              <div class="points h4 pb-3">{{ points }}</div>
              <div v-if="!chapterEnded">
                <h4 class="pt-3" v-html="$t('chapter5.slide3.wait')"></h4>
                <div class="progress">
                  <div class="progress-bar progress-bar-striped bg-danger" role="progressbar" v-bind:style="{width: progress + '%'}"></div>
                </div>
              </div>
              <div v-else>
                <button class="btn btn-danger" @click="toScoreboard">{{ $t('chapter5.slide3.scoreboard') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'Chapter5',
  components: {
    Header, Footer
  },
  data: function () {
    return {
      pw: 'asdkfjhtmnbvasdfknedsfDSF',
      chapter: 5,
      slide: 1,
      currentTimer: 0,
      currentRiddle: 0,
      currentRiddleError: false,
      errors: [false, false, false, false, false, false, false, false, false, false, false, false, false],
      showFinal: true,
      gameResult: null,
      points: 0,
      progress: 0,
      chapterEnded: false,
      riddles: [
        {
          input: '',
          solutions: ['10'],
          solutionText: '012259145938',
          solutionTimer: 10,
          hintsShown: [false, false],
          showHint: [false, false],
          showSolution: false,
          causesStrikes: [true, true],
          strikeValues: [60, 60],
          strikes: [0, 0],
          riddleSlide: 2,
          nextSlide: 3
        }
      ],
      strikes: [0]
    }
  },
  computed: {
    video: function () {
      if (this.slide === 3) {
        return 'https://tabbot-central.b-cdn.net/video/papstBG.mp4'
      }
      return 'https://tabbot-central.b-cdn.net/video/BinaryNumbers2.mp4'
    },
    isVisible: function (errorNr) {
      return (this.errors[errorNr] ? 'visible' : 'hidden')
    },
    collectedStrikes: function () {
      const strikes = []
      for (let r = 0; r < this.riddles.length; r++) {
        strikes.push(this.riddles[r].strikes)
      }
      return strikes
    }
  },
  methods: {
    calcTimer: function () {
      const d = new Date()
      let riddleTimer = 0
      for (let i = 0; i <= this.currentRiddle; i++) {
        riddleTimer += this.riddles[i].solutionTimer * 60
      }
      this.currentTimer = (this.$store.state.currentTimer + riddleTimer) - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds())
      if (this.currentTimer > 0) {
        setTimeout(this.calcTimer, 500)
      } else {
        this.currentTimer = 0
        setTimeout(this.calcTimer, 500)
        this.chapterEnded = true
      }
      if (this.currentTimer === 0 && this.slide === this.riddles[this.currentRiddle].riddleSlide) {
        this.riddles[this.currentRiddle].showSolution = true
      }
      if (this.$refs.finale && this.$refs.finale.currentTime > 13) {
        this.showFinal = false
      }
      this.progress = 100 - (this.currentTimer / (10 * 60) * 100)
    },
    errorFound: function (errorNr) {
      this.errors[errorNr] = true
      this.checkSolution()
    },
    navigateTo: function (slide) {
      if (event) {
        event.preventDefault()
      }
      this.slide = slide
    },
    checkSolution: function (riddle) {
      event.preventDefault()
      let counter = 0
      for (let i = 1; i <= this.errors.length; i++) {
        if (this.errors[i] === true) {
          counter += 1
        }
      }
      if (counter >= 7) {
        setTimeout(this.finishChapter, 2000)
      }
    },
    saveHints: function () {
      const cookieDate = new Date()
      let expires = ';expires='
      cookieDate.setTime(cookieDate.getTime() + 86400000)
      expires += cookieDate.toGMTString()
      const strikes = []
      for (let r = 0; r < this.riddles.length; r++) {
        strikes.push(this.riddles[r].strikes)
      }
      document.cookie = 'strikes-' + this.chapter + '=' + JSON.stringify(strikes) + expires
    },
    showHint: function (riddle, hint) {
      event.preventDefault()
      this.riddles[riddle].showHint[hint] = true
      this.riddles[riddle].hintsShown[hint] = true
      this.riddles[riddle].strikes[hint] = this.riddles[riddle].strikeValues[hint]
      this.headerKey += 1
      this.saveHints()
    },
    closeHint: function () {
      for (const riddle in this.riddles) {
        for (const hint in this.riddles[riddle].showHint) {
          this.riddles[riddle].showHint[hint] = false
        }
      }
    },
    toScoreboard: function () {
      this.$store.commit('updateGameState', 'chapter6')
    },
    nextRiddle: function () {
      for (const riddle in this.riddles) {
        this.riddles[riddle].showSolution = false
      }
      // Chapter finnished?
      if (this.currentRiddle + 1 >= this.riddles.length) {
        this.finishChapter()
        return
      }
      this.slide = this.riddles[this.currentRiddle].nextSlide
      this.currentRiddle += 1
    },
    countPoints: function () {
      if (this.gameResult) {
        let seconds = 0
        for (let chapter = 1; chapter <= 5; chapter++) {
          if (this.gameResult['chapter' + chapter]) {
            const t = this.gameResult['chapter' + chapter]
            const tArr = t.split(':')
            seconds += parseInt(tArr[1]) * 60 + parseInt(tArr[2])
            console.log(t, tArr, seconds)
          }
        }
        this.points = seconds
      } else {
        this.points = 0
      }
    },
    finishChapter: function () {
      let strikes = 0
      for (let r = 0; r < this.riddles.length; r++) {
        for (let s = 0; s < this.riddles[r].strikes.length; s++) {
          strikes += this.riddles[r].strikes[s]
        }
      }
      this.currentTimer -= strikes
      if (this.currentTimer < 0) {
        this.currentTimer = 0
      }
      // SEND USER TO BACKEND
      axios.get('http://admin.tabbot-central.com/setChapterData.php', {
        params: {
          token: this.pw,
          username: this.$store.state.username,
          teamname: this.$store.state.teamname,
          chapter: this.chapter,
          time: this.currentTimer
        }
      }).then(response => {
        console.log(response)
        this.gameResult = response.data.gamedata
        this.currentTimer = 0
        this.countPoints()
        this.navigateTo(3)
      }).catch(error => {
        console.log(error)
        this.errorType = 'couldNotLoginUser'
        this.loginError = true
      })
    }
  },
  created: function () {
    const cookies = document.cookie.split('; ').reduce((prev, current) => {
      const [name, value] = current.split('=')
      prev[name] = value
      return prev
    }, {})
    if (cookies['strikes-' + this.chapter]) {
      const strikes = JSON.parse(cookies['strikes-' + this.chapter])
      for (let r = 0; r < this.riddles.length; r++) {
        this.riddles[r].strikes = strikes[r]
      }
    }
    this.calcTimer()
  }
}
</script>
